import BlogPostThumbnail from "./BlogPostThumbnail";
export default BlogPostThumbnail;
